try {
    if (process.env.TOKENS_FEATURE_FLAG === 'true' || process.env.STORYBOOK_TOKENS_FEATURE_FLAG !== 'false') require('./index-new.css');
    else require('./index.css');
  } catch (e) {
    if (e.code !== 'MODULE_NOT_FOUND') {
      throw e; // Re-throw unexpected errors
    }
    console.warn('index.css / index-new.css not found, proceeding without it.');
  }


import { jsx, jsxs } from 'react/jsx-runtime';
import { Card } from '@design-system/card';
import { TraitGroup } from '@design-system/trait-group';
import classNames from 'classnames';
import { RetailersBlock } from '@design-system/retailers-block';
import { WhereToBuy } from '@design-system/where-to-buy';

const NONE = 'none';
const THIRD_PARTY = '3rd party';
const RETAILERS = 'retailers';

const BuyNowButton = ({ buyNowButton, retailers, whereToBuyData }) => {
    switch (buyNowButton.type) {
        case RETAILERS:
            return (retailers && (jsx(RetailersBlock, Object.assign({}, retailers, { isDropdown: true, buttonLabel: buyNowButton.label }))));
        case THIRD_PARTY:
            return whereToBuyData && jsx(WhereToBuy, Object.assign({}, whereToBuyData));
        case NONE:
        default:
            return null;
    }
};

const BASE_CLASS = 'cds-product-card';
const ProductCard = ({ className, link, variant, cardContent, cardCta, cardMedia, cardLabel, shopifyBlockComponent, categories, traitGroup, buyNowButton, retailers, whereToBuyData, }) => {
    const { headingBlock, disclaimer, category } = cardContent;
    const categoryClasses = (categories === null || categories === void 0 ? void 0 : categories.map((title) => `${BASE_CLASS}--${title}`)) || [];
    return (jsxs(Card, Object.assign({ className: classNames(BASE_CLASS, ...categoryClasses, className), hasMedia: !!cardMedia, variant: variant }, { children: [jsxs(Card.CardContent, Object.assign({ headingBlock: Object.assign(Object.assign({}, headingBlock), { headlineLink: link }), disclaimer: disclaimer, category: category }, { children: [traitGroup && jsx(TraitGroup, Object.assign({}, traitGroup)), cardCta && jsx(Card.CardCTA, Object.assign({}, cardCta)), buyNowButton && (jsx(BuyNowButton, { buyNowButton: buyNowButton, retailers: retailers, whereToBuyData: whereToBuyData })), shopifyBlockComponent] })), cardMedia || cardLabel ? (jsx(Card.CardMedia, Object.assign({}, cardMedia, { children: cardLabel && jsx(Card.CardLabel, Object.assign({}, cardLabel)) }))) : null] })));
};

export { ProductCard };
